import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Clientreview from "./Clientsreview/Clientreview";
import Main from "./Main/Main";
import Animations from "./Animations/Animation";
import ScrollToTopButton from "./Scrolltotop/ScrollToTopButton";
import Techstack from "./Techstack/Techstack";
import Webdevelopment from "./WebDevelopment/Webdevelopment";
import Homeportfolio from "./Homeportfolio/Homeportfolio";
import Bgimage from "./Bgimagesection/Bgimage";
import Blogs from "./Blogs/Blogs";
import Footer from "../../components/Footer/Footer";
import Ourclients from "./Ourclients/Ourclients";
import Ourservice from "./Ourservice/Ourservice";
import { Helmet } from "react-helmet-async";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";

function HomepageMain() {
  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Dwebbox | Custom Software Development & UI/UX Design Agency</title>
        <meta
          name="description"
          content="Dwebbox is a premier software development agency specializing in Web Development, App Development, and UI/UX Design. We help businesses scale through digital transformation and innovative online products."
        />
        <meta
          name="keywords"
          content="software development agency, web development, mobile app development, UI/UX design, digital transformation, e-commerce solutions, Dwebbox"
        />
        <link
          rel="canonical"
          href="https://dwebbox.com/"
        />
        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Dwebbox",
            "url": "https://dwebbox.com",
            "logo": "https://dwebbox.com/logo192.png",
            "sameAs": [
              "https://www.linkedin.com/company/dwebbox",
              "https://twitter.com/dwebbox"
            ],
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-8828103808",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>

      <ScrollToTopButton />
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <Main />
      <Animations />
      <Homeportfolio />
      <Ourservice />

      <Webdevelopment />

      <Ourclients />
      <Clientreview />
      <Techstack />
      <Blogs />
      <Bgimage />
      <Footer />
    </div>
  );
}

export default HomepageMain;
